/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyledPropertyListContainerDiv } from './index.styles';
import { PropertyCardComponent } from '../PropertyCardV0';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { PaginationPanel } from '@marriott/mi-ui-library-shop';
import { useConditionalSearchResultAlertContextSERP } from '../../hooks/lib/useConditionalSearchResultAlertContext';
import { useConditionalSearchResultContextSERP } from '../../hooks/lib/useConditionalSearchResultContext';
import { SearchActions } from '../../organisms/SearchResults/store/store.action';
import {
  SearchFacetsConstants,
  propertyCardHiddenAlertCodes,
  alertRatesUnavailableWarning,
} from '../../organisms/SearchResults/index.constant';
import { AlertNotification } from '../alerts/AlertNotification';
import { PaginationSortByComponent } from '../paginationSortBy';
import { MemberExclusiveBanner } from '../memberExclusiveBanner';
import { logger } from '../../utils';
import { Messages } from '@marriott/mi-ui-library';
import { getAlertsData, isUnsuccessfulUserJourney } from '../../organisms/SearchResults/lib/helper';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { StyledSearchResultMapContainer } from '../../organisms/SearchResults/index.styles';
import { useConditionalPageContextSERP } from '../../hooks';
import clsx from 'clsx';
import { useCheckBreakpoint } from '../../hooks';
import { MapLazyComponent } from '../mapComponent/MapLazyComponent';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import {
  getPriceByDecimalPoint,
  getCurrentPriceRateBlock,
  getCurrRateAmountBlock,
} from '../../organisms/SearchResults/lib/helper';
import { SearchRateType } from '../../organisms/SearchResults/store/store.type';
import { EEO_TYPE } from '../../modules/constants';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
import { OCard } from '../oCard/index';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
const PropertyListComponent: React.FC<{
  isMobileState?: boolean;
  handleStaleError?: boolean;
  memberExclusiveBannerDetails?: {
    featureSelected: boolean;
    numberOfNights: number;
    pointsChecked: boolean;
  };
  alertLinkClickFn: () => void;
  handlePopUpOpen: (popUpOenState: boolean) => void;
  enableListView: (listViewClicked: boolean) => void;
  handleNextClick?: (isInitialLoadData: boolean) => void;
  isDrawerVisible: boolean;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  segmentId?: string;
  isLatLongAvailable?: boolean;
  isCorpCodeEntered?: boolean;
  onOpenHotelPanel?: (propertyData: any, propertyId: string) => void;
  hasRetried?: boolean;
  retryFailedWithWarn1000?: boolean;
  warnRates1000RelatedWarningBlock?: { code?: string; devMessage?: string; message?: string };
}> = ({
  isMobileState = false,
  handleStaleError = false,
  memberExclusiveBannerDetails,
  alertLinkClickFn,
  handlePopUpOpen,
  enableListView,
  handleNextClick,
  isDrawerVisible,
  segmentId,
  isLatLongAvailable,
  setFetchCurrencyConversionFactors,
  isCorpCodeEntered,
  onOpenHotelPanel,
  hasRetried,
  retryFailedWithWarn1000,
  warnRates1000RelatedWarningBlock,
}) => {
  const {
    isMapViewEnabled,
    setFeatureSelected,
    isFlexibleDateSearch,
    jsonContent,
    isStaticMap,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchResult } = useConditionalSearchResultContextSERP();
  const { searchQueryState, setSearchQuery } = useConditionalSearchFilterContextWithSerpFlag();
  const { searchResultAlerts, setSearchResultAlerts } = useConditionalSearchResultAlertContextSERP();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { currentLocale, pageVal } = useConditionalPageContextSERP();
  const [loadAllResults, setLoadAllResults] = useState<boolean>(pageVal === 'chat' ? true : false);
  const [isNGSFSerp, setIsNGSFSerp] = useState<boolean>(false);
  const [mapViewPlacementHeight, setMapViewPlacementHeight] = useState<string | null>(null);
  const [mapViewHeight, setMapViewHeight] = useState<string | null>(null);
  const loadAll = useRef<boolean>(false);
  const mapViewContainerRef = useRef<HTMLDivElement | null>(null);

  const searchResults = searchResult?.edges;
  const geoCodeInfo = searchResult?.geoCodeInfo;
  const messageUiData = searchResult?.messageUiData || {};
  const llmMetadata = searchResult?.llmMetadata || {};

  const PageSize = searchQueryState[SearchFacetsConstants.limit];

  const { log } = logger({})('SearchResults/propertyList');

  log.debug('search result', searchResult);

  const [currentPage, setCurrentPage] = useState(
    Number(searchResult?.pageInfo?.currentOffset ? searchResult?.currentOffset : 0) !== 0 &&
      searchQueryState?.currentCurrency !== 'default'
      ? Math.ceil((Number(searchResult?.pageInfo?.currentOffset) + 1) / PageSize)
      : searchQueryState[SearchFacetsConstants.offset] !== 0
      ? Math.ceil((searchQueryState[SearchFacetsConstants.offset] + 1) / PageSize)
      : 1
  );

  const handleScroll = () => {
    if (!loadAll.current) {
      setLoadAllResults(true);
      loadAll.current = true;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      setIsNGSFSerp(params.get('isNGSF') === 'true');
    }
  }, []);

  const onPageItemClick = (page: number): void => {
    setFetchCurrencyConversionFactors(true);
    setFeatureSelected(true);
    setCurrentPage(page);
    setPageNumber(page);
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: PageSize * (page ? page - 1 : 0),
        [SearchFacetsConstants.goToNextPage]: PageSize * (page ? page - 1 : 0),
      },
    });
    setInteractionsSelected({ ...interactionsSelected, pagination: true });
  };

  const getDataProperty = (result: {
    node: {
      property: { basicInformation: any; id: any };
      rates: SearchRateType[] | undefined;
      basicInformation: any;
      id: any;
    };
  }) => {
    const currRateNode = getCurrentPriceRateBlock(searchQueryState, result?.node?.rates);
    const currRateDetails = getCurrRateAmountBlock(currRateNode);

    let priceInfo: any;
    // update logic for priceInfo depending on amountPlusMandatoryFees/amount
    if (currRateDetails?.amountPlusMandatoryFees) {
      priceInfo = isFlexibleDateSearch ? null : currRateDetails?.amountPlusMandatoryFees;
    } else {
      priceInfo = isFlexibleDateSearch ? null : currRateDetails?.amount;
    }
    const basicInformation = result?.node?.property?.basicInformation;
    const flexibleInformation = result?.node?.basicInformation;
    const amountObj = priceInfo;

    const dataPropObj = {
      lat: isFlexibleDateSearch ? flexibleInformation?.latitude : basicInformation?.latitude,
      long: isFlexibleDateSearch ? flexibleInformation?.longitude : basicInformation?.longitude,
      brand: isFlexibleDateSearch ? flexibleInformation?.brand?.id : basicInformation?.brand?.id,
      marshacode: isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id,
      hwsInLanguageMissing: 'false',
      currency: basicInformation?.currency,

      price: getPriceByDecimalPoint(
        amountObj?.amount,
        amountObj?.decimalPoint,
        searchQueryState,
        currentLocale,
        amountObj?.currency
      ),
      hotelName: basicInformation?.name,
      propMarkerLabel: '',
      propMarkerBedLabel: '',
    };
    return JSON.stringify(dataPropObj);
  };
  const noRatesAreAvailable = useSearchResultsStore(
    (state: { noRatesAreAvailable: any }) => state.noRatesAreAvailable
  ).noRatesAreAvailable;
  const [noRatesAvailableForAnyProperty, setNoRatesAvailableForAnyProperty] = useState(false);

  useEffect(() => {
    if (noRatesAreAvailable?.noRatesAvailableForAnyProperty) {
      setNoRatesAvailableForAnyProperty(true);
      setSearchResultAlerts(
        getAlertsData(
          jsonContent?.alertsListArray?.filter(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (key: any) => key.alertMsgTypeName === alertRatesUnavailableWarning
          )[0]?.alertCodeListModel[0],
          'warning'
        )
      );
    }
  }, [noRatesAreAvailable?.noRatesAvailableForAnyProperty]);

  const isViewportXL = useCheckBreakpoint('viewportXl');
  const isViewportM = useCheckBreakpoint('viewportM');
  const updateMapViewPlacementHeight = useCallback(() => {
    if (typeof window === 'undefined' || !isMapViewEnabled || !mapViewContainerRef.current) {
      return;
    }

    const { top } = mapViewContainerRef.current.getBoundingClientRect();

    // Calculate height for property list (with spacing for pagination)
    const BOTTOM_SPACING_OFFSET = 12;
    const occupiedHeightInRem = (top + BOTTOM_SPACING_OFFSET) / 16;
    const mapViewOffsets = [17, 22, 25];
    const calculatedOffsetInRem =
      mapViewOffsets.find(offset => occupiedHeightInRem <= offset) ?? mapViewOffsets[mapViewOffsets.length - 1];
    const calculatedHeight = `calc(100vh - ${calculatedOffsetInRem}rem)`;

    // Calculate exact height for map (to touch bottom of viewport)
    const exactMapHeight = `calc(100vh - ${top}px)`;

    setMapViewPlacementHeight(prevHeight => (prevHeight === calculatedHeight ? prevHeight : calculatedHeight));
    setMapViewHeight(prevHeight => (prevHeight === exactMapHeight ? prevHeight : exactMapHeight));
  }, [isMapViewEnabled]);

  useEffect(() => {
    if (!isMapViewEnabled || typeof window === 'undefined') {
      setMapViewPlacementHeight(null);
      setMapViewHeight(null);
      return;
    }

    updateMapViewPlacementHeight();

    const timeoutIds = [0, 150, 400].map(delay =>
      window.setTimeout(() => {
        updateMapViewPlacementHeight();
      }, delay)
    );

    window.addEventListener('resize', updateMapViewPlacementHeight);

    return () => {
      timeoutIds.forEach(timeoutId => window.clearTimeout(timeoutId));
      window.removeEventListener('resize', updateMapViewPlacementHeight);
    };
  }, [isMapViewEnabled, updateMapViewPlacementHeight, searchResults?.length, searchResultAlerts]);

  return (
    <div
      className={
        isMapViewEnabled
          ? clsx(
              'search-results-container',
              'color-scheme1',
              'search-map-view-result-container'
              // isDrawerVisible ? 'active-drawer' : '',
              // popPupOpen ? 'map-popup-position' : ''
            )
          : 'search-results-container'
      }
    >
      {/* For chat context: always render list but hide with CSS when map is active (prevents remount delay) */}
      {/* For non-chat: keep existing conditional rendering behavior */}
      {(pageVal === 'chat' || (!(isMapViewEnabled && !isViewportM) && !isStaticMap)) && (
        <StyledPropertyListContainerDiv className={pageVal === 'chat' && isMapViewEnabled ? 'd-none' : ''}>
          <div
            className={clsx(
              isViewportXL && !isDrawerVisible && isMapViewEnabled ? `active-drawer-list` : ``,
              !isViewportXL && isMapViewEnabled ? `active-drawer-list` : ``
            )}
          >
            <div
              ref={mapViewContainerRef}
              style={
                mapViewPlacementHeight
                  ? ({ '--gp-placement-max-height': mapViewPlacementHeight } as React.CSSProperties)
                  : undefined
              }
              className={clsx(
                pageVal === 'chat' ? 'property-card-outer-container-chat' : 'property-card-outer-container ',
                'container pr-0 pl-0',
                isMapViewEnabled ? `color-scheme1 outer-map-view-class` : ``,
                isMapViewEnabled && isNGSFSerp ? 'gp-placement-ngsf' : ''
              )}
            >
              {!memberExclusiveBannerDetails?.featureSelected &&
                isMapViewEnabled &&
                (memberExclusiveBannerDetails?.numberOfNights ?? 0) >= 4 &&
                memberExclusiveBannerDetails?.pointsChecked && (
                  <MemberExclusiveBanner
                    numberOfNights={memberExclusiveBannerDetails.numberOfNights}
                    pointsChecked={memberExclusiveBannerDetails.pointsChecked}
                  />
                )}
              {isMapViewEnabled && (
                <PaginationSortByComponent
                  isMobileState={isMobileState}
                  className="pagination-container propertyList pb-md-2"
                  segmentId={segmentId}
                  isLatLongAvailable={isLatLongAvailable}
                  isCorpCodeEntered={isCorpCodeEntered}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              )}
              {isMapViewEnabled && searchResultAlerts?.errorMessage && !isUnsuccessfulUserJourney() ? (
                <AlertNotification
                  setLinkClick={alertLinkClickFn}
                  clickTrackingText="Phoenix Search Results | Alert: Set default currency link clicked |internal"
                />
              ) : (
                ''
              )}
              {isMapViewEnabled &&
              searchResultAlerts?.errorMessage &&
              searchResultAlerts?.showPageAndFilter &&
              isUnsuccessfulUserJourney() ? (
                <Messages
                  className="unsuccess-full-journey"
                  messageType="warning"
                  messageVariation={false}
                  messageHeading={searchResultAlerts?.heading}
                  messageText={searchResultAlerts?.errorMessage}
                  messageContentTabIndex={0}
                  messageRole="alert"
                />
              ) : (
                ''
              )}
              {isMapViewEnabled &&
              searchResultAlerts?.showPageAndFilter &&
              !isUnsuccessfulUserJourney() &&
              hasRetried &&
              !retryFailedWithWarn1000 &&
              warnRates1000RelatedWarningBlock?.message &&
              searchResultAlerts?.type !== 'unsuccessfulSell' ? (
                <Messages
                  className="unsuccess-full-journey"
                  messageType="warning"
                  messageVariation={false}
                  messageText={warnRates1000RelatedWarningBlock?.message}
                  messageContentTabIndex={0}
                  messageRole="alert"
                />
              ) : (
                ''
              )}
              <div
                className={
                  ' property-card-container ' +
                  (isMapViewEnabled ? ` map-view-selected ` : ``) +
                  (searchResultAlerts?.errorMessage ? 'with-alerts' : '')
                }
              >
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                {!propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') &&
                  searchResults?.map((result: any, idx: any) => {
                    return (
                      <div
                        className={clsx(' property-card', pageVal === 'chat' ? 'mx-0' : '')}
                        key={idx}
                        data-marsha={isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id}
                        data-brand={
                          isFlexibleDateSearch
                            ? result?.node?.basicInformation?.brand?.id
                            : result?.node?.property?.basicInformation?.brand?.id
                        }
                        data-map="true"
                        data-property={getDataProperty(result)}
                        data-pnum={idx}
                      >
                        {(!loadAllResults && idx < 10) || loadAllResults || isMapViewEnabled ? (
                          <PropertyCardComponent
                            propertyHandleStaleError={handleStaleError}
                            propertyCardData={result}
                            idx={idx}
                            handlePopUpOpen={handlePopUpOpen}
                            pageNumber={pageNumber}
                            noRatesAvailableForAnyProperty={noRatesAvailableForAnyProperty}
                            onOpenHotelPanel={onOpenHotelPanel}
                            messageUiData={messageUiData}
                          />
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
            {!isMapViewEnabled && pageVal === 'chat' && (
              <OCard
                title="Looking for more properties?"
                buttonText="Search All Properties"
                geoCodeInfo={geoCodeInfo}
                llmMetadata={llmMetadata}
              />
            )}
            {pageVal === 'chat' && <div className="buffer-section"></div>}
            {isMapViewEnabled ? <div className="separator t-horizontal-vertical-rule"></div> : ''}
            {pageVal !== 'chat' && !propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') && (
              <div className=" pagination-container">
                <PaginationPanel
                  currentPage={currentPage}
                  totalCount={searchResult?.total ?? 0}
                  pageSize={PageSize}
                  onPageChange={(page: number): void => onPageItemClick(page)}
                  currentLocale={currentLocale}
                />
              </div>
            )}
          </div>
        </StyledPropertyListContainerDiv>
      )}
      {(isMapViewEnabled || isStaticMap) && (
        <StyledSearchResultMapContainer className={clsx('map-container', pageVal === 'chat' && 'chat-map-container')}>
          <MapLazyComponent
            isMapViewEnabled={true}
            onListViewClickHandler={enableListView}
            handleNextClick={handleNextClick}
            isDrawerVisible={isDrawerVisible}
            onOpenHotelPanel={onOpenHotelPanel}
            mapViewPlacementHeight={mapViewHeight}
          />
        </StyledSearchResultMapContainer>
      )}
    </div>
  );
};

export default PropertyListComponent;
